(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.ManageUsersService = (function(superClass) {
    extend(ManageUsersService, superClass);

    function ManageUsersService(http, rootScope) {
      this.http = http;
      this.rootScope = rootScope;
      this.deleteUser = bind(this.deleteUser, this);
      this.changeActivity = bind(this.changeActivity, this);
      this.updateRoles = bind(this.updateRoles, this);
      this.editRoles = bind(this.editRoles, this);
      this.updateContactInfo = bind(this.updateContactInfo, this);
      this.editContactInfo = bind(this.editContactInfo, this);
      this.viewAccountInfo = bind(this.viewAccountInfo, this);
      this.updateUserCompanies = bind(this.updateUserCompanies, this);
      this.getUserCompanies = bind(this.getUserCompanies, this);
      this.getUsers = bind(this.getUsers, this);
      void 0;
    }

    ManageUsersService.prototype.getUsers = function() {
      return this.http.post('backend/admin/new-tools/manage-users/get-users');
    };

    ManageUsersService.prototype.getUserCompanies = function(user_id) {
      return this.http.post('backend/admin/new-tools/manage-users/get-user-companies', {
        user_id: user_id
      });
    };

    ManageUsersService.prototype.updateUserCompanies = function(user_id, company_ids) {
      return this.http.post('backend/admin/new-tools/manage-users/update-user-companies', {
        user_id: user_id,
        company_ids: company_ids
      });
    };

    ManageUsersService.prototype.viewAccountInfo = function(user_id) {
      return this.http.post('backend/admin/new-tools/manage-users/view-account-info', {
        user_id: user_id
      });
    };

    ManageUsersService.prototype.editContactInfo = function(user_id) {
      return this.http.post('backend/admin/new-tools/manage-users/edit-contact-info', {
        user_id: user_id
      });
    };

    ManageUsersService.prototype.updateContactInfo = function(user) {
      return this.http.post('backend/admin/new-tools/manage-users/update-contact-info', {
        user: user
      });
    };

    ManageUsersService.prototype.editRoles = function(user_id) {
      return this.http.post('backend/admin/new-tools/manage-users/edit-roles', {
        user_id: user_id
      });
    };

    ManageUsersService.prototype.updateRoles = function(user, companies_users) {
      return this.http.post('backend/admin/new-tools/manage-users/update-roles', {
        user_id: user.id,
        is_myfarms_employee: user.is_myfarms_employee,
        on_payroll: user.on_payroll,
        companies_users: companies_users
      });
    };

    ManageUsersService.prototype.changeActivity = function(user_id, activate) {
      return this.http.post('backend/admin/new-tools/manage-users/change-activity', {
        user_id: user_id,
        activate: activate
      });
    };

    ManageUsersService.prototype.deleteUser = function(user_id) {
      return this.http.post('backend/admin/new-tools/manage-users/delete-user', {
        user_id: user_id
      });
    };

    return ManageUsersService;

  })(Service);

}).call(this);
